exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-centered[data-v-ebe1b828]{margin:0;left:45%;top:50%}", ""]);

// exports
